"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
require("rxjs/add/observable/fromPromise");
require("rxjs/add/operator/catch");
require("rxjs/add/operator/map");
require("rxjs/add/operator/mergeMap");
var Observable_1 = require("rxjs/Observable");
var http_1 = require("@angular/common/http");
var HttpGroupService = /** @class */ (function () {
    function HttpGroupService(applicationPropertiesService, http) {
        this.applicationPropertiesService = applicationPropertiesService;
        this.http = http;
    }
    HttpGroupService_1 = HttpGroupService;
    HttpGroupService.prototype.getByCriteria = function (criteriaDto) {
        var _this = this;
        return this.getGroupServiceUrl(HttpGroupService_1.GROUPS_BY_CRITERIA).flatMap(function (url) {
            return _this.http.post(url, criteriaDto)
                .catch(HttpGroupService_1.handleError);
        });
    };
    HttpGroupService.prototype.getById = function (groupId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(groupId);
        var placeHolders = new Map().set("{groupId}", groupId.toString());
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_BY_ID, placeHolders).flatMap(function (url) {
            return _this.http.get(url)
                .catch(HttpGroupService_1.handleError);
        });
    };
    HttpGroupService.prototype.create = function (groupDataDto) {
        var _this = this;
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_CREATE)
            .flatMap(function (url) { return _this.http.post(url, groupDataDto); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.update = function (groupDataDto) {
        var _this = this;
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_UPDATE)
            .flatMap(function (url) { return _this.http.put(url, groupDataDto); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.delete = function (groupId, deletedById) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(groupId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(deletedById);
        var placeHolders = new Map()
            .set("{groupId}", groupId.toString())
            .set("{deletedById}", deletedById.toString());
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_DELETE, placeHolders)
            .flatMap(function (url) { return _this.http.delete(url); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getRoles = function (groupId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(groupId);
        var placeHolders = new Map().set("{groupId}", groupId.toString());
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_ROLES, placeHolders)
            .flatMap(function (url) { return _this.http.get(url); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getUsers = function (groupId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(groupId);
        var placeHolders = new Map().set("{groupId}", groupId.toString());
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_USERS, placeHolders)
            .flatMap(function (url) { return _this.http.get(url); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getAvailableOrganizations = function (userId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userId);
        var params = new http_1.HttpParams();
        params = params.set('userId', userId.toString());
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_ORGANIZATIONS)
            .flatMap(function (url) { return _this.http.get(url, { params: params }).map(function (organizations) {
            return organizations.sort(function (a, b) { return a.name.localeCompare(b.name); });
        }); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getAvailableRoles = function (userId, organizationId, languageId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(organizationId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageId);
        var params = new http_1.HttpParams();
        params = params.set('userId', userId.toString());
        params = params.set('organizationId', organizationId.toString());
        params = params.set('languageId', languageId.toString());
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_AVAILABLE_ROLES)
            .flatMap(function (url) { return _this.http.get(url, { params: params }); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getAvailableUsers = function (organizationId, userId, languageId, selectedRoleIds) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(organizationId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(selectedRoleIds);
        var params = new http_1.HttpParams();
        params = params.set('organizationId', organizationId.toString());
        params = params.set('userId', userId.toString());
        params = params.set('languageId', languageId.toString());
        params = params.set('roleIds', selectedRoleIds.toString());
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_AVAILABLE_USERS)
            .flatMap(function (url) { return _this.http.get(url, { params: params }); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getPagedAvailableUsers = function (usersSearchDto) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(usersSearchDto);
        return this.getGroupServiceUrl(HttpGroupService_1.GROUP_AVAILABLE_USERS)
            .flatMap(function (url) { return _this.http.post(url, usersSearchDto); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getRoleAvailableGroups = function (roleId, userId, languageId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(userId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(roleId);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(languageId);
        var params = new http_1.HttpParams();
        params = params.set('userId', userId.toString());
        params = params.set('roleId', roleId.toString());
        params = params.set('languageId', languageId.toString());
        return this.getGroupServiceUrl(HttpGroupService_1.ROLE_AVAILABLE_GROUPS)
            .flatMap(function (url) { return _this.http.get(url, { params: params }); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.updateRoleGroups = function (roleGroupsDto) {
        var _this = this;
        return this.getGroupServiceUrl(HttpGroupService_1.ROLE_GROUPS_UPDATE)
            .flatMap(function (url) { return _this.http.put(url, roleGroupsDto); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getRoleGroups = function (roleId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(roleId);
        var params = new http_1.HttpParams();
        params = params.set('roleId', roleId.toString());
        return this.getGroupServiceUrl(HttpGroupService_1.ROLE_GROUPS)
            .flatMap(function (url) { return _this.http.get(url, { params: params }); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getByIds = function (groupIds) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(groupIds);
        return this.getGroupServiceUrl(HttpGroupService_1.GROUPS_BY_IDS)
            .flatMap(function (url) { return _this.http.post(url, groupIds); })
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.getGroupServiceUrl = function (extension, placeHolders) {
        var _this = this;
        return Observable_1.Observable.fromPromise(this.applicationPropertiesService.getProperty(HttpGroupService_1.UM_SERVICE_URL_KEY)
            .then(function (groupServiceBase) { return groupServiceBase + HttpGroupService_1.GROUP_SERVICE_BASE_PATH + extension; })
            .then(function (url) { return _this.replacePlaceholders(url, placeHolders); }))
            .catch(HttpGroupService_1.handleError);
    };
    HttpGroupService.prototype.replacePlaceholders = function (url, placeHolders) {
        return url.replace(/{\w+}/g, function (all) {
            return placeHolders.get(all) || all;
        });
    };
    HttpGroupService.handleError = function (error) {
        console.error(error);
        return Observable_1.Observable.throw(error);
    };
    HttpGroupService.UM_SERVICE_URL_KEY = "um-service-url";
    HttpGroupService.GROUP_SERVICE_BASE_PATH = "/groups";
    HttpGroupService.GROUPS_BY_CRITERIA = "/bycriteria";
    HttpGroupService.GROUP_BY_ID = "/{groupId}";
    HttpGroupService.GROUP_CREATE = "/";
    HttpGroupService.GROUP_UPDATE = "/";
    HttpGroupService.GROUP_DELETE = "/{groupId}/{deletedById}";
    HttpGroupService.GROUP_ROLES = "/{groupId}/roles";
    HttpGroupService.GROUP_USERS = "/{groupId}/users";
    HttpGroupService.GROUP_ORGANIZATIONS = "/organizations";
    HttpGroupService.GROUP_AVAILABLE_ROLES = "/availableroles";
    HttpGroupService.GROUP_AVAILABLE_USERS = "/availableusers";
    HttpGroupService.ROLE_AVAILABLE_GROUPS = "/roleavailablegroups";
    HttpGroupService.ROLE_GROUPS_UPDATE = "/rolegroups";
    HttpGroupService.ROLE_GROUPS = "";
    HttpGroupService.GROUPS_BY_IDS = "/byids";
    HttpGroupService = HttpGroupService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_authentication_client_js_1.HttpClientWrapper])
    ], HttpGroupService);
    return HttpGroupService;
    var HttpGroupService_1;
}());
exports.HttpGroupService = HttpGroupService;
//# sourceMappingURL=http-group.service.js.map